import React, { useState, useContext, useEffect, useRef } from 'react'
import * as s from './styles'
import Icon from '../../icon'
import Submenu, { Subitem } from '../submenu'
import { NavbarContext } from '..'
import uuid from 'react-uuid'

type Props = {
  children?: JSX.Element
  icon?: string
  profilePicture?: string
  submenu?: Subitem[]
  event?: () => void
  uuid?: string
  notification?: boolean
}

const MenuItem: React.FC<any> = (props: Props): JSX.Element => {
  const showIcon = !!props.icon
  const showProfilePicture = !props.icon && props.profilePicture
  const showChildren = !!props.children
  const menuRef = useRef(null)
  const [submenuId] = useState(uuid())
  const { openSubmenuId, setOpenSubmenuId } = useContext(NavbarContext)
  const [isSubmenuVisible, setSubmenuVisibility] = useState(
    openSubmenuId == submenuId,
  )
  const showSubmenu = !!props.submenu && isSubmenuVisible

  const toggleSubmenu = (): void => {
    const willBeVisible = !showSubmenu

    setSubmenuVisibility(willBeVisible)
    setOpenSubmenuId(willBeVisible ? submenuId : null)
  }

  useEffect(() => {
    if (openSubmenuId != submenuId) {
      setSubmenuVisibility(false)
    }
  }, [openSubmenuId])

  const handleClick = (e) => {
    if (menuRef.current && menuRef.current.contains(e.target)) {
      return
    }
    setSubmenuVisibility(false)
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClick)
    return () => {
      document.removeEventListener('mousedown', handleClick)
    }
  }, [])

  return (
    <s.MenuItem>
      <s.Container ref={menuRef}>
        <s.Button onClick={props.submenu ? toggleSubmenu : props.event}>
          {showChildren && <s.Text> {props.children} </s.Text>}

          {showProfilePicture && <s.Picture src={props.profilePicture} />}

          {showIcon && (
            <Icon
              name={props.icon}
              color={
                showSubmenu ? 'brandColorPrimaryPure' : 'neutralColorLowMedium'
              }
            />
          )}
          {props.notification && <s.Notification />}
        </s.Button>
        {showSubmenu && <Submenu subitems={props.submenu} />}
      </s.Container>
    </s.MenuItem>
  )
}

export default MenuItem
